import { Valence } from '@upright/common/model/types';
import { Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';

export function valenceToSide(valence: Valence): Side {
  if (valence === Valence.POSITIVE) {
    return Side.RIGHT;
  }
  return Side.LEFT;
}
